import {
  ITableFields,
  TABLE_FIELD_ALIGN,
  TABLE_FIELD_TYPE,
} from "../../core-component/ui/ICTable";
import { IPagination } from "../../data/AppInterface";
import {
  TBitValue,
  TReactSetState,
  TSetPaginationFn,
  TUseTranslationTfn,
} from "../../data/AppType";
import {
  ACTIVE_INACTIVE_HELP_CATEGORY,
  DELETE_HELP_CATEGORY,
  GET_ALL_HELP_CATEGORY,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
  toastSuccess,
} from "../../utils/AppFunctions";

export interface IHelpCategory {
  id: string;
  category_title: string;
  category_description: string;
  display_sequence: number;
  is_active: TBitValue;
  created_by: string;
  created_date: string;
  modified_by: string | null;
  modified_date: Date | null;
}
export function getHelpCategoryFields<T>(
  actionComponent: (item: T) => JSX.Element,
  handleHelpCategoryStatus: (item: T) => void,
  t: TUseTranslationTfn
): ITableFields<T>[] {
  return [
    {
      name: t("category_title"),
      key: "category_title",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("display_sequence"),
      key: "display_sequence",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },
    {
      name: t("status"),
      key: "is_active",
      sort: false,
      type: TABLE_FIELD_TYPE.switch,
      align: TABLE_FIELD_ALIGN.center,
      checkedValue: "1",
      flex: "col-span-2",
      handleCheck: handleHelpCategoryStatus,
    },
    {
      name: t("created_by"),
      key: "created_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("created_date"),
      key: "created_date",
      sort: false,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-3",
    },
    {
      name: t("modified_by"),
      key: "modified_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },
    {
      name: t("modified_date"),
      key: "modified_date",
      sort: false,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-3",
    },
    {
      name: t("action"),
      key: "action",
      sort: false,
      type: TABLE_FIELD_TYPE.custom,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-1",
      component: actionComponent,
    },
  ];
}

export const getAllHelpCategory = async (
  setHelpCategoryList: TReactSetState<IHelpCategory[]>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  search: string
) => {
  try {
    const response = await GET_ALL_HELP_CATEGORY(pagination, search);
    if (
      response &&
      response.code === DEFAULT_STATUS_CODE_SUCCESS &&
      response.data
    ) {
      setHelpCategoryList(response.data.item);
      setPagination(response.data.pagination);
    } else {
      setHelpCategoryList([]);
      sweetAlertError({
        message: response?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAllHelpCategory");
  }
};

export const activeInactiveHelpCategory = async (
  id: string,
  value: TBitValue
) => {
  try {
    const response = await ACTIVE_INACTIVE_HELP_CATEGORY(id, {
      is_active: value,
    });
    if (response?.code === DEFAULT_STATUS_CODE_SUCCESS) {
      toastSuccess(response.message);
      return true;
    } else {
      sweetAlertError({
        message: response?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (error) {
    handleError(error, "activeInactiveHelpCategory");
    return false;
  }
};

export const deleteHelpCategory = async (id: string) => {
  try {
    const deleteData = await DELETE_HELP_CATEGORY(id);
    if (deleteData && deleteData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess({ message: deleteData.message });
      return true;
    } else {
      sweetAlertError({
        message: deleteData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "deleteHelpCategory");
    return false;
  }
};
